var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcMessenger(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "33px",
    viewBox: "0 0 32 33",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "messenger") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Share-outside-Sekeron---Done",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Sharing-any-post-outside-sekeron-171",
    transform: "translate(-716, -724)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-60",
    transform: "translate(676, 380)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-59",
    transform: "translate(0, 30)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-54",
    transform: "translate(0, 74)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-46",
    transform: "translate(0, 76)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "messenger",
    transform: "translate(40, 164.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.9984443,0.0031114829 C7.35209756,-0.167371939 0.197418302,6.6892113 0,15.3349331 C0.0225603062,19.7359426 1.9713083,23.906412 5.33279392,26.7471358 L5.33279392,31.3333773 C5.33279392,31.701529 5.6312649,32 5.9994166,32 C6.12434195,32 6.24676754,31.9648784 6.35269474,31.8986974 L10.0683334,29.5776106 C11.9613993,30.3016652 13.9716414,30.6708792 15.9984443,30.6668171 C24.644791,30.8373006 31.7994702,23.9807173 31.9968885,15.3349956 C31.7994702,6.6892113 24.644791,-0.167371939 15.9984443,0.0031114829 Z",
    id: "Path",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5307326,10.9353609 C26.3323769,10.6695117 25.9687247,10.589957 25.677503,10.7486915 L18.7448647,14.528324 L14.4319716,10.8299961 C14.1674973,10.6032682 13.7730357,10.6183292 13.5267471,10.8646803 L5.52752499,18.8639024 C5.26798772,19.125002 5.2692376,19.547086 5.53039971,19.8066232 C5.7391919,20.0141655 6.05934827,20.0601611 6.3181356,19.9197997 L13.250774,16.1401673 L17.5676667,19.8398075 C17.8321409,20.0665354 18.2266026,20.0514744 18.4728911,19.8051234 L26.4721133,11.8059012 C26.7052156,11.5706116 26.7302132,11.1998352 26.5307326,10.9353609 Z",
    id: "Path",
    fill: "#FAFAFA"
  }))))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMessenger);
export default __webpack_public_path__ + "static/media/ic_messenger.4b8843bac3f47e57d7a2b5db915a9243.svg";
export { ForwardRef as ReactComponent };